import Axios from 'axios'

export default {
  userLoad (Vue) {
    Axios.get(`${Vue.$apiUrl}/check-auth`).then((res) => {
      if (res.data) {
        Vue.$store.commit('set', {type: 'userData', items: res.data})
        Vue.$requiredFields.forEach((key) => {
          if (!res.data[key]) {
            Vue.$store.commit('var', {type: 'authVar', i: 'signUp', v: true})
          }
        })
        this.subscribePush(Vue)
      }
    }).catch((err) => {
      if (err.response.status === 401) return
      Vue.$notice['error']({
        title: err.response.statusText,
        description: err.response.data
      })
    })
  },
  userSignUp (Vue, credentials) {
    let looper = false
    Object.keys(credentials).map((key, index) => {
      if (looper) return
      if (!credentials[key]) {
        Vue.$notice['warning']({
          title: Vue.$t('auth.warning'),
          description: Vue.$t('auth.field_required')
        })
        looper = true
      } else {
        if (credentials[key].length > 50) {
          Vue.$notice['warning']({
            title: Vue.$t('hack.warning'),
            description: Vue.$t('hack.tooLong')
          })
          looper = true
        } else {
          if (key === 'password2' &&
            credentials['password2'] !== credentials['password']) {
            Vue.$notice['warning']({
              title: Vue.$t('auth.warning'),
              description: Vue.$t('auth.password_math')
            })
            looper = true
          }
          Vue.$store.commit('var', {type: 'userData', i: key, v: credentials[key]})
        }
      }
    })
    Vue.$store.commit(
      'var',
      {
        type: 'userData',
        i: 'locale',
        v: Vue.$i18n.locale
      }
    )
    if (looper) return
    Vue.$data.loading = true
    let obj = Vue.$store.state.userData
    Axios.post(`${Vue.$apiUrl}/signUp`, obj).then((res) => {
      if (res.status === 200 && res.data) {
        Vue.$store.commit('set', {type: 'userData', items: res.data})
        Vue.$store.commit('var', {type: 'authVar', i: 'signUp', v: false})
        Vue.$data.loading = false
        this.sendPulse(Vue)
      }
    }).catch((err) => {
      Vue.$data.loading = false
      Vue.$notice['error']({
        title: err.response.statusText,
        description: err.response.data
      })
    })
  },
  helloAuth (Vue, network) {
    const hello = Vue.hello
    hello(network).login({
      scope: 'email'
    }).then(() => {
      const authRes = hello(network).getAuthResponse()
      if (!authRes.access_token) {
        return Vue.$notice['error']({
          title: Vue.$t('auth.error'),
          description: Vue.$t('auth.auth_fail')
        })
      }
      hello(network).api('me').then((json) => {
        let credentials = {
          regFrom: network,
          profile: json
        }
        Axios.post(`${Vue.$apiUrl}/socialAuth`, credentials).then((res) => {
          if (res.data) {
            Vue.$store.commit('set', {type: 'userData', items: res.data})
            Vue.$requiredFields.forEach((key) => {
              if (!res.data[key]) {
                Vue.$store.commit('var', {type: 'authVar', i: 'signUp', v: true})
              }
            })
            Vue.$store.commit('var', {type: 'authVar', i: 'login', v: false})
          }
        }).catch((err) => {
          Vue.$notice['error']({
            title: err.response.statusText,
            description: err.response.data
          })
        })
      })
    })
  },
  updateSocial (Vue, credentials) {
    let userData = Vue.$store.state.userData
    let looper = false
    Vue.$requiredFields.forEach((key) => {
      if (looper) return
      if (!userData[key]) {
        if (credentials[key]) {
          if (credentials[key].length > 50) {
            Vue.$notice['warning']({
              title: Vue.$t('hack.warning'),
              description: Vue.$t('hack.tooLong')
            })
            looper = true
          } else {
            Vue.$store.commit('var', {type: 'userData', i: key, v: credentials[key]})
          }
        } else {
          Vue.$notice['warning']({
            title: Vue.$t('auth.warning'),
            description: Vue.$t('auth.field_required')
          })
          looper = true
        }
      }
    })
    Vue.$store.commit(
      'var',
      {
        type: 'userData',
        i: 'locale',
        v: Vue.$i18n.locale
      }
    )
    if (looper) return
    Vue.$data.loading = true
    Axios.post(`${Vue.$apiUrl}/updateSocial`, Vue.$store.state.userData).then((res) => {
      Vue.$data.loading = false
      Vue.$store.commit('var', {type: 'authVar', i: 'signUp', v: false})
      this.sendPulse(Vue)
    }).catch((err) => {
      Vue.$data.loading = false
      Vue.$notice['error']({
        title: err.response.statusText,
        description: err.response.data
      })
    })
  },
  signIn (Vue) {
    let credentials = {
      email: Vue.$data.email,
      password: Vue.$data.password
    }
    if (credentials.email.length > 50 || credentials.password.length > 50) {
      return Vue.$notice['warning']({
        title: Vue.$t('hack.warning'),
        description: Vue.$t('hack.tooLong')
      })
    }
    if (credentials.email.length < 2 || credentials.password.length < 2) {
      return Vue.$notice['warning']({
        title: Vue.$t('auth.warning'),
        description: Vue.$t('auth.field_required')
      })
    }
    Vue.$data.signing = true
    Axios.post(`${Vue.$apiUrl}/signIn`, credentials).then((res) => {
      if (res.data) {
        Vue.$store.commit('set', {type: 'userData', items: res.data})
        Vue.$store.commit('var', {type: 'authVar', i: 'login', v: false})
      }
    }).catch((err) => {
      Vue.$data.signing = false
      Vue.$notice['error']({
        title: err.response.statusText,
        description: err.response.data
      })
    })
  },
  logOut (Vue) {
    Axios.post(`${Vue.$apiUrl}/logOut`).then((res) => {
      location.reload()
    }).catch((err) => {
      Vue.$notice['error']({
        title: err.response.statusText,
        description: err.response.data
      })
    })
  },
  sendPulse (Vue) {
    const convertPhone = (phone) => {
      if (phone.substr(0, 1) === '0') return `+373${phone.substr(1)}`
      return `+373${phone}`
    }
    let credentials = {
      'email': Vue.$store.state.userData.email,
      'variables': {
        'Name': Vue.$store.state.userData.firstName,
        'Last_name': Vue.$store.state.userData.lastName,
        'Birth_date': Vue.$store.state.userData.birthDate,
        'Phone': convertPhone(Vue.$store.state.userData.phone),
        'Registered_from': Vue.$store.state.userData.socialFrom,
        'Language': Vue.$i18n.locale,
        'site': 'fifa2018'
      }
    }
    Axios.post(`${Vue.$apiUrl}/sendPulseApi`, credentials)

    let forNotification = {
      'email': credentials['email'],
      'phone': credentials['variables']['Phone'],
      'Name': credentials['variables']['Name'],
      'Last_name': credentials['variables']['Last_name'],
      'Language': credentials['variables']['Language']
    }
    Axios.post(`${Vue.$apiUrl}/pulseNotification`, forNotification)

    this.subscribePush()
  },
  subscribePush (Vue) {
    // eslint-disable-next-line
    oSpP.push('Name', Vue.$store.state.userData.name)
    // eslint-disable-next-line
    oSpP.push('Last_name', Vue.$store.state.userData.lastName)
    // eslint-disable-next-line
    oSpP.push('Email', Vue.$store.state.userData.email)
  },
  recover (Vue) {
    Vue.$data.sending = true
    let obj = {
      email: Vue.$data.email,
      phone: Vue.$data.phone,
      lang: Vue.$i18n.locale
    }
    Axios.post(`${Vue.$apiUrl}/passwordRecovery`, obj).then((res) => {
      if (res.data) {
        Vue.$notice['success']({
          title: 'Ура',
          description: res.data
        })
        Vue.$data.sending = false
        Vue.$store.commit('var', { type: 'authVar', i: 'recovery', v: false })
      }
    }).catch((err) => {
      Vue.$data.sending = false
      Vue.$notice['error']({
        title: err.response.statusText,
        description: err.response.data
      })
    })
  },
  fbAuth (Vue, dude) {
    let credentials = {
      regFrom: 'facebook',
      profile: dude
    }
    credentials.profile.thumbnail = `https://graph.facebook.com/${credentials.profile.id}/picture`
    Axios.post(`${Vue.$apiUrl}/socialAuth`, credentials).then((res) => {
      if (res.data) {
        Vue.$store.commit('set', {type: 'userData', items: res.data})
        Vue.$requiredFields.forEach((key) => {
          if (!res.data[key]) {
            Vue.$store.commit('var', {type: 'authVar', i: 'signUp', v: true})
          }
        })
        Vue.$store.commit('var', {type: 'authVar', i: 'login', v: false})
      }
    }).catch((err) => {
      Vue.$notice['error']({
        title: err.response.statusText,
        description: err.response.data
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/AuthForm/index.js